import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'PARTNER_UPDATE',
    smsDelete : 'PARTNER_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        partner: [],
        partnerLoading: false,
        partnerError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_PARTNER(state, partner) {
            state.partner = partner;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        PARTNER_LOADING (state, loading) {
            state.partnerLoading = loading;
        },

        PARTNER_ERROR (state, hasError) {
            state.partnerError = hasError;
        }
    },

    actions: {
        // PARTNER
        async addPartner ({commit, dispatch}, payload) {
            commit('PARTNER_LOADING', true);
            commit('PARTNER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_partner, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPartner')
                return response

            } catch (e) {
                commit('PARTNER_ERROR', true);
            } finally {
                commit('PARTNER_LOADING', false);
            }
        },

        async fetchPartner ({commit, dispatch}) {
            commit('PARTNER_LOADING', true);
            commit('PARTNER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.partner_list, config);
                let response = result.data
                commit('SET_PARTNER', response.data);

            } catch(error) {
                commit('PARTNER_ERROR', true);
            } finally {
                commit('PARTNER_LOADING', false);
            }
        },

        async updatePartner ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_partner + payload.id, payload.partner, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPartner')
                return response

            } catch (e) {
                commit('PARTNER_ERROR', true);
            } finally {
                commit('PARTNER_LOADING', false);
            }
        },
        
        async deletePartner({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.partner_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchPartner')
            return response
        }
    },

    getters: {}
}
